// ===== ONLY ONE IMPORT AT THE TOP - DUPLICATE REMOVED =====
import { useState, useEffect, useRef } from "react";
import emailjs from "@emailjs/browser";
import { db } from "../firebase";
import {
  collection,
  addDoc,
  query,
  where,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";

// ===== IMPORT YOUR CUSTOM BANNER IMAGES HERE =====
import banner1 from "../assets/images/banner-1.PNG";
import banner2 from "../assets/images/banner-2.PNG";

import StoreNavbar from "../components/StoreNavbar";
import StoreTicker from "../components/StoreTicker";

// ===== CUSTOM BANNER SLIDER IMAGES =====
const sliderImages = [
  {
    id: 101,
    image: banner1,
    name: "Summer Sale!",
    description: "Up to 50% off on all products",
    price: 0,
    originalPrice: 0,
    rating: 0,
    badge: "bestseller",
  },
  {
    id: 102,
    image: banner2,
    name: "New Collection",
    description: "Discover our latest learning tools",
    price: 0,
    originalPrice: 0,
    rating: 0,
    badge: "new",
  },
];

// ===== PAKISTAN CITIES LIST =====
const pakistanCities = [
  "Karachi", "Lahore", "Islamabad", "Rawalpindi", "Faisalabad", "Multan",
  "Hyderabad", "Gujranwala", "Peshawar", "Quetta", "Sialkot", "Bahawalpur",
  "Sargodha", "Sukkur", "Larkana", "Sheikhupura", "Mardan", "Gujrat",
  "Kasur", "Rahim Yar Khan", "Sahiwal", "Okara", "Wah Cantonment",
  "Dera Ghazi Khan", "Mingora", "Nawabshah", "Chiniot", "Kotri",
  "Jamshoro", "Hafizabad", "Mandi Bahauddin", "Jhelum", "Khanewal",
  "Muzaffargarh", "Abbottabad", "Mansehra", "Swat", "Gilgit", "Skardu",
  "Mirpur", "Muzaffarabad", "Kotli", "Bhimber"
];

// ===== EMAILJS CONFIGURATION =====
const EMAILJS_SERVICE_ID = "service_vzruywc";
const EMAILJS_TEMPLATE_ID_OWNER = "template_titz2qe";
const EMAILJS_TEMPLATE_ID_CUSTOMER = "template_bkosl1p";
const EMAILJS_PUBLIC_KEY = "eDYNScLAjuESZDj7O";

const FREE_DELIVERY_THRESHOLD = 3000;
const DELIVERY_CHARGE_LAHORE = 250;
const DELIVERY_CHARGE_OTHER = 300;

const display = { fontFamily: "'Fraunces', serif" };
const body = { fontFamily: "'Work Sans', sans-serif" };

// ===== FALLBACK CATEGORY FOR OLD PRODUCTS THAT HAVE NO category FIELD =====
const DEFAULT_CATEGORY = "Flashcards";

// A few nice icons for known categories. Any category not listed here
// (a brand-new one you add from the admin dropdown) just gets a generic
// icon automatically — nothing needs to be updated here for new categories.
const CATEGORY_ICONS = {
  Flashcards: "📇",
  Alphabet: "🔤",
  Boards: "🪵",
  Books: "📚",
  Toys: "🧸",
};
const getCategoryIcon = (cat) => CATEGORY_ICONS[cat] || "🏷️";

// ============================================================
// ============== PRODUCT IMAGE SLIDER COMPONENT ===============
// ============================================================
const extractGoogleDriveId = (url) => {
  if (!url) return null;
  const match = url.match(/\/d\/([^/]+)/);
  return match ? match[1] : null;
};

const getGoogleDriveImageUrl = (url) => {
  if (!url) return "";
  if (!url.includes("drive.google.com")) return url;
  const fileId = extractGoogleDriveId(url);
  if (!fileId) return url;
  return `https://drive.google.com/thumbnail?id=${fileId}&sz=w1000`;
};

const ProductImageSlider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  const timerRef = useRef(null);

  // Filter out empty/null images
  const validImages = images.filter(img => img && img.trim() !== '');

  useEffect(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    if (validImages.length > 1 && !isHovering) {
      timerRef.current = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % validImages.length);
      }, 3000);
    }
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [isHovering, validImages.length]);

  if (validImages.length <= 1) {
    return (
      <div className="relative w-full aspect-square bg-[#EDF1E6] overflow-hidden">
        {validImages.length === 1 ? (
          <img
            src={getGoogleDriveImageUrl(validImages[0])}
            alt="Product"
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500 ease-out"
            onError={(e) => {
              e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Crect width='200' height='200' fill='%23EDF1E6'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='%236B7A6E' font-size='14' font-family='sans-serif'%3ENo Image%3C/text%3E%3C/svg%3E";
            }}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#6B7A6E]">No Image</div>
        )}
      </div>
    );
  }

  const goToSlide = (index) => setCurrentIndex(index);
  const goToPrev = (e) => { e.stopPropagation(); setCurrentIndex((prev) => (prev - 1 + validImages.length) % validImages.length); };
  const goToNext = (e) => { e.stopPropagation(); setCurrentIndex((prev) => (prev + 1) % validImages.length); };

  return (
    <div
      className="relative w-full aspect-square bg-[#EDF1E6] overflow-hidden"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <img
        src={getGoogleDriveImageUrl(validImages[currentIndex])}
        alt="Product"
        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500 ease-out"
        onError={(e) => {
          e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Crect width='200' height='200' fill='%23EDF1E6'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='%236B7A6E' font-size='14' font-family='sans-serif'%3ENo Image%3C/text%3E%3C/svg%3E";
        }}
      />

      {/* Navigation Arrows */}
      {validImages.length > 1 && (
        <>
          <button
            className="absolute top-1/2 -translate-y-1/2 left-2 bg-black/40 hover:bg-black/60 text-white rounded-full w-6 h-6 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity text-sm z-10"
            onClick={goToPrev}
          >
            ‹
          </button>
          <button
            className="absolute top-1/2 -translate-y-1/2 right-2 bg-black/40 hover:bg-black/60 text-white rounded-full w-6 h-6 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity text-sm z-10"
            onClick={goToNext}
          >
            ›
          </button>

          {/* Dots */}
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1.5 z-10">
            {validImages.map((_, idx) => (
              <span
                key={idx}
                className={`w-1.5 h-1.5 rounded-full transition-all ${idx === currentIndex ? 'bg-[#E8B84B] w-4' : 'bg-white/70'}`}
                onClick={() => goToSlide(idx)}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

function StarRating({ rating, size = "text-sm" }) {
  const full = Math.floor(rating);
  const half = rating - full >= 0.5;
  const empty = 5 - full - (half ? 1 : 0);
  return (
    <span className={`inline-flex items-center gap-1 ${size}`}>
      <span className="text-[#E8B84B] leading-none">
        {"★".repeat(full)}
        {half ? "⯨" : ""}
        {"☆".repeat(empty)}
      </span>
      <span className="text-[#3E5645]/70 font-semibold">{rating.toFixed(1)}</span>
    </span>
  );
}

// Back button component
function BackButton({ onClick, label = "Back to Store" }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 text-white text-sm hover:bg-[#1A4FB0] transition-all duration-300 group font-semibold bg-[#2F6FED] px-5 py-3 rounded-xl shadow-lg hover:shadow-xl border border-[#2F6FED]/30 hover:scale-[1.02] active:scale-[0.98]"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-5 h-5 group-hover:-translate-x-1.5 transition-transform duration-300"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="15 18 9 12 15 6"></polyline>
      </svg>
      <span>{label}</span>
    </button>
  );
}

// ============================================================
// ============== 🎉 CUSTOM ALERT COMPONENT ===============
// ============================================================
const CustomAlert = ({ isOpen, onClose, title, message, icon, category }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/50 backdrop-blur-sm animate-[fadeIn_0.3s_ease-out]">
      <div className="bg-white rounded-2xl max-w-md w-full p-6 shadow-2xl transform animate-[scaleIn_0.3s_ease-out] border border-[#E8B84B]/20">
        {/* Icon & Title */}
        <div className="flex flex-col items-center text-center mb-4">
          <div className="w-16 h-16 rounded-full bg-[#E8B84B]/15 flex items-center justify-center mb-3">
            <span className="text-3xl">{icon || "📚"}</span>
          </div>
          <h3 className="text-xl font-bold text-[#3E5645]">{title}</h3>
          <p className="text-[#6B7A6E] text-sm mt-1">{message}</p>
        </div>

        {/* Category Badge */}
        {category && (
          <div className="flex justify-center mb-4">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-[#3E5645]/10 rounded-full text-sm font-semibold text-[#3E5645] border border-[#3E5645]/15">
              <span className="text-lg">{getCategoryIcon(category)}</span>
              {category}
            </span>
          </div>
        )}

        {/* Products Count */}
        <div className="text-center text-sm text-[#6B7A6E] mb-4">
          Showing products in this category
        </div>

        {/* OK Button */}
        <button
          onClick={onClose}
          className="w-full py-3 bg-[#2F6FED] hover:bg-[#1E4FC7] text-white font-semibold rounded-xl transition-colors shadow-lg hover:shadow-xl"
        >
          OK, Let's Go! ✨
        </button>
      </div>
    </div>
  );
};

function Store() {
  const navigate = useNavigate();
  const [showAllReviews, setShowAllReviews] = useState(false);
  const [cart, setCart] = useState(() => {
    try {
      const saved = localStorage.getItem("mbu_cart");
      return saved ? JSON.parse(saved) : [];
    } catch (error) {
      console.error("Cart load error:", error);
      return [];
    }
  });
  const [cartOpen, setCartOpen] = useState(false);
  const [view, setView] = useState("store");
  const [form, setForm] = useState({ name: "", phone: "", email: "", address: "", city: "", notes: "" });
  const [sending, setSending] = useState(false);
  const [slideIndex, setSlideIndex] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [reviewName, setReviewName] = useState("");
  const [reviewRating, setReviewRating] = useState(0);
  const [reviewComment, setReviewComment] = useState("");
  const [hoverRating, setHoverRating] = useState(0);
  const [submittingReview, setSubmittingReview] = useState(false);
  const [isCityDropdownOpen, setIsCityDropdownOpen] = useState(false);
  const [searchCity, setSearchCity] = useState("");

  // ===== CATEGORY ALERT STATE =====
  const [categoryAlert, setCategoryAlert] = useState({
    isOpen: false,
    title: "",
    message: "",
    icon: "",
    category: "",
  });

  const [dbProducts, setDbProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState("All");

  // Auto slide effect for Banners
  useEffect(() => {
    const timer = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % sliderImages.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    localStorage.setItem("mbu_cart", JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [view]);

  // ===== LIVE-FETCH products from Firestore =====
  useEffect(() => {
    setLoading(true);
    const unsubscribe = onSnapshot(
      collection(db, "products"),
      (snapshot) => {
        const data = snapshot.docs.map((docSnap) => {
          const d = docSnap.data();
          return {
            id: docSnap.id,
            name: d.name || "Unnamed Product",
            price: d.sellingPrice || d.price || 0,
            originalPrice: d.originalPrice || d.price || 0,
            rating: d.rating || 5,
            // Fetching all images separately
            image: d.imageUrl || "",
            imageUrl2: d.imageUrl2 || null,
            imageUrl3: d.imageUrl3 || null,
            imageUrl4: d.imageUrl4 || null,
            description: d.description || "",
            badge: d.badge || null,
            category: d.category || DEFAULT_CATEGORY,
          };
        });
        setDbProducts(data);
        setLoading(false);
        console.log("✅ Products loaded from Firestore:", data.length);
      },
      (error) => {
        console.error("❌ Products fetch error:", error);
        setLoading(false);
      }
    );
    return () => unsubscribe();
  }, []);

  // ===== REVIEWS: Sirf selected product ke reviews =====
  useEffect(() => {
    if (!selectedProduct) {
      setReviews([]);
      return;
    }

    const q = query(
      collection(db, "reviews"),
      where("product_id", "==", selectedProduct.id),
      orderBy("createdAt", "desc")
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setReviews(data);
      },
      (error) => {
        console.error("❌ Reviews fetch error:", error);
      }
    );

    return () => unsubscribe();
  }, [selectedProduct]);

  function addToCart(product) {
    setCart((prev) => {
      const existing = prev.find((i) => i.id === product.id);
      if (existing) return prev.map((i) => (i.id === product.id ? { ...i, qty: i.qty + 1 } : i));
      return [...prev, { ...product, qty: 1 }];
    });
    setCartOpen(true);
  }

  function updateQty(id, qty) {
    if (qty < 1) return setCart((prev) => prev.filter((i) => i.id !== id));
    setCart((prev) => prev.map((i) => (i.id === id ? { ...i, qty } : i)));
  }

  function removeItem(id) {
    setCart((prev) => prev.filter((i) => i.id !== id));
  }

  // ===== SUBMIT REVIEW =====
  function submitReview(e) {
    e.preventDefault();

    if (!reviewName.trim()) {
      alert("Please enter your name");
      return;
    }
    if (reviewRating === 0) {
      alert("Please select a rating");
      return;
    }
    if (!reviewComment.trim()) {
      alert("Please write a comment");
      return;
    }
    if (!selectedProduct) {
      alert("No product selected");
      return;
    }

    setSubmittingReview(true);

    const reviewData = {
      product_id: selectedProduct.id,
      product_name: selectedProduct.name,
      name: reviewName.trim(),
      rating: reviewRating,
      comment: reviewComment.trim(),
      createdAt: new Date(),
    };

    addDoc(collection(db, "reviews"), reviewData)
      .then(() => {
        setReviewName("");
        setReviewRating(0);
        setReviewComment("");
        setSubmittingReview(false);
        alert("✅ Review submitted successfully!");
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      })
      .catch((err) => {
        console.error("❌ Review submit error:", err);
        setSubmittingReview(false);
        alert("❌ Review submit nahi hui. Error: " + err.message);
      });
  }

  const avgRating =
    reviews.length > 0
      ? (reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(1)
      : 0;
  const subtotal = cart.reduce((sum, i) => sum + i.price * i.qty, 0);
  const totalItems = cart.reduce((sum, i) => sum + i.qty, 0);

  const getDeliveryCharge = () => {
    if (subtotal >= FREE_DELIVERY_THRESHOLD) return 0;
    return form.city === "Lahore" ? DELIVERY_CHARGE_LAHORE : DELIVERY_CHARGE_OTHER;
  };

  const deliveryCharge = getDeliveryCharge();
  const grandTotal = subtotal + deliveryCharge;

  function handleFormChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function handleCitySelect(city) {
    setForm({ ...form, city: city });
    setIsCityDropdownOpen(false);
    setSearchCity("");
  }

  const filteredCities = pakistanCities.filter(city =>
    city.toLowerCase().includes(searchCity.toLowerCase())
  );

  // ===== PLACE ORDER =====
  async function placeOrder(e) {
    e.preventDefault();

    if (!form.name || !form.phone || !form.email || !form.address || !form.city) {
      alert("Please fill all required fields");
      return;
    }

    if (cart.length === 0) {
      alert("Your cart is empty");
      return;
    }

    setSending(true);

    const orderDetails =
      cart.map((i) => `${i.name} x${i.qty} = Rs.${i.price * i.qty}`).join("\n") +
      `\n\nDelivery Charges = ${deliveryCharge === 0 ? "Free" : `Rs.${deliveryCharge}`}` +
      `\nTotal = Rs.${grandTotal}`;

    try {
      const orderRef = await addDoc(collection(db, "orders"), {
        customerName: form.name,
        phone: form.phone,
        email: form.email,
        address: form.address,
        city: form.city,
        notes: form.notes || "",
        items: cart,
        subtotal: subtotal,
        deliveryCharge: deliveryCharge,
        total: grandTotal,
        status: "Pending",
        createdAt: new Date(),
      });

      try {
        await emailjs.send(
          EMAILJS_SERVICE_ID,
          EMAILJS_TEMPLATE_ID_OWNER,
          {
            customer_name: form.name,
            customer_phone: form.phone,
            customer_email: form.email,
            customer_address: form.address,
            customer_city: form.city,
            customer_notes: form.notes || "N/A",
            order_items: orderDetails,
            order_total: `Rs.${grandTotal}`,
            order_id: orderRef.id,
          },
          EMAILJS_PUBLIC_KEY
        );

        await emailjs.send(
          EMAILJS_SERVICE_ID,
          EMAILJS_TEMPLATE_ID_CUSTOMER,
          {
            to_email: form.email,
            customer_name: form.name,
            customer_address: form.address,
            customer_city: form.city,
            order_items: orderDetails,
            order_total: `Rs.${grandTotal}`,
            order_id: orderRef.id,
          },
          EMAILJS_PUBLIC_KEY
        );

      } catch (emailError) {
        console.error("❌ Email Error:", emailError);
        alert("⚠️ Order saved! But email could not be sent. We will contact you shortly.");
      }

      setSending(false);
      setView("success");
      setCart([]);

    } catch (err) {
      console.error("❌ Order Save Error:", err);
      alert("Order save nahi hua. Error: " + err.message);
      setSending(false);
    }
  }

  const navigateToStore = () => {
    setView("store");
    setSelectedProduct(null);
    setReviews([]);
  };

  const goBack = () => {
    navigate(-1);
  };

  // ===== 🎯 HANDLE CATEGORY CLICK WITH ALERT =====
  const handleCategoryClick = (category) => {
    setActiveCategory(category);

    // Count products in this category
    const count = category === "All" 
      ? dbProducts.length 
      : dbProducts.filter(p => (p.category || DEFAULT_CATEGORY) === category).length;

    // Show custom alert
    setCategoryAlert({
      isOpen: true,
      title: category === "All" ? "🛍️ All Products" : `${getCategoryIcon(category)} ${category}`,
      message: category === "All" 
        ? `Showing all ${count} products in the store` 
        : `Showing ${count} products in "${category}" category`,
      icon: category === "All" ? "🛍️" : getCategoryIcon(category),
      category: category === "All" ? null : category,
    });
  };

  // ===== CLOSE CATEGORY ALERT =====
  const closeCategoryAlert = () => {
    setCategoryAlert({ ...categoryAlert, isOpen: false });
  };

  // ===== BADGE RENDER FUNCTION =====
  const renderBadge = (badge) => {
    switch (badge) {
      case 'bestseller':
        return (
          <div className="absolute top-3 left-3 bg-gradient-to-r from-[#3E5645] to-[#2F4538] text-white text-[10px] font-bold uppercase tracking-wider px-3 py-1.5 rounded-full shadow-lg flex items-center gap-1.5 border border-white/20">
            <span className="text-[#E8B84B]">🏆</span>
            Best Seller
          </div>
        );
      case 'new':
        return (
          <div className="absolute top-3 left-3 bg-gradient-to-r from-[#C0563E] to-[#A04535] text-white text-[10px] font-bold uppercase tracking-wider px-3 py-1.5 rounded-full shadow-lg flex items-center gap-1.5 border border-white/20">
            <span className="text-[#E8B84B]">✨</span>
            New
          </div>
        );
      case 'sale':
        return (
          <div className="absolute top-3 left-3 bg-gradient-to-r from-[#E8B84B] to-[#D4A83A] text-[#3E5645] text-[10px] font-bold uppercase tracking-wider px-3 py-1.5 rounded-full shadow-lg flex items-center gap-1.5 border border-white/30">
            <span>🔥</span>
            Sale
          </div>
        );
      case 'trending':
        return (
          <div className="absolute top-3 left-3 bg-gradient-to-r from-[#4A90D9] to-[#357ABD] text-white text-[10px] font-bold uppercase tracking-wider px-3 py-1.5 rounded-full shadow-lg flex items-center gap-1.5 border border-white/20">
            <span>📈</span>
            Trending
          </div>
        );
      case 'limited':
        return (
          <div className="absolute top-3 left-3 bg-gradient-to-r from-[#8B4513] to-[#6B3410] text-white text-[10px] font-bold uppercase tracking-wider px-3 py-1.5 rounded-full shadow-lg flex items-center gap-1.5 border border-white/20">
            <span>⚡</span>
            Limited
          </div>
        );
      default:
        return null;
    }
  };

  // ===== DYNAMIC CATEGORY TABS =====
  const categoryTabs = [
    "All",
    ...Array.from(new Set(dbProducts.map((p) => p.category || DEFAULT_CATEGORY))).sort(),
  ];

  const filteredDbProducts =
    activeCategory === "All"
      ? dbProducts
      : dbProducts.filter((p) => (p.category || DEFAULT_CATEGORY) === activeCategory);

  return (
    <div className="w-full bg-[#FBF9F2]" style={body}>
      {/* ===== CUSTOM ALERT ===== */}
      <CustomAlert
        isOpen={categoryAlert.isOpen}
        onClose={closeCategoryAlert}
        title={categoryAlert.title}
        message={categoryAlert.message}
        icon={categoryAlert.icon}
        category={categoryAlert.category}
      />

      <StoreNavbar
        totalItems={totalItems}
        onCartClick={() => setCartOpen(true)}
      />

      <div className="pt-[72px]">
        <StoreTicker />
      </div>

      {view === "store" && (
        <div className="max-w-6xl mx-auto px-4 sm:px-8 pt-3 sm:pt-4 pb-2 sm:pb-3">
          <BackButton onClick={goBack} label=" Back to Home" />
        </div>
      )}

      {/* ========== HERO BANNER SLIDER ========== */}
      {view === "store" && (
        <div className="relative px-3 sm:px-6 pt-2 sm:pt-3">
          <div className="relative w-full max-w-6xl mx-auto h-[180px] sm:h-[280px] md:h-[380px] lg:h-[450px] overflow-hidden rounded-2xl sm:rounded-3xl shadow-2xl">
            {sliderImages.map((slide, index) => (
              <div
                key={slide.id}
                className="absolute inset-0 transition-all duration-700 ease-in-out"
                style={{
                  opacity: index === slideIndex ? 1 : 0,
                  transform: `scale(${index === slideIndex ? 1 : 1.05})`,
                  pointerEvents: index === slideIndex ? "auto" : "none",
                  zIndex: index === slideIndex ? 1 : 0,
                }}
              >
                <img
                  src={slide.image}
                  alt={slide.name}
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent sm:from-black/60 sm:via-black/20"></div>
                <div className="absolute inset-0 hidden sm:flex flex-col items-center justify-center text-center px-6">
                  {slide.badge && (
                    <span className={`inline-block text-xs tracking-[0.2em] uppercase font-bold mb-3 px-4 py-1.5 rounded-full backdrop-blur-sm ${slide.badge === "bestseller"
                      ? "bg-[#E8B84B] text-[#2F4538]"
                      : "bg-white/20 text-white border border-white/30"
                      }`}>
                      {slide.badge === "bestseller" ? "🏆 Best Seller" : "✨ New"}
                    </span>
                  )}
                  <h1 className="text-white text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-3 drop-shadow-lg" style={display}>
                    {slide.name}
                  </h1>
                  <p className="text-white/90 text-base md:text-lg lg:text-xl mb-0 max-w-2xl drop-shadow">
                    {slide.description}
                  </p>
                </div>
                <div className="absolute bottom-3 left-0 right-0 text-center sm:hidden">
                  <span className="inline-block bg-black/50 text-white text-[10px] font-semibold px-3 py-1 rounded-full backdrop-blur-sm">
                    {slide.name}
                  </span>
                </div>
              </div>
            ))}
            <button
              onClick={() => setSlideIndex((prev) => (prev - 1 + sliderImages.length) % sliderImages.length)}
              className="absolute left-2 sm:left-4 md:left-5 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 rounded-full bg-black/40 hover:bg-black/60 text-white flex items-center justify-center backdrop-blur-sm transition-all duration-300 text-2xl sm:text-3xl md:text-4xl z-10 hover:scale-110 shadow-lg"
            >
              ‹
            </button>
            <button
              onClick={() => setSlideIndex((prev) => (prev + 1) % sliderImages.length)}
              className="absolute right-2 sm:right-4 md:right-5 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 rounded-full bg-black/40 hover:bg-black/60 text-white flex items-center justify-center backdrop-blur-sm transition-all duration-300 text-2xl sm:text-3xl md:text-4xl z-10 hover:scale-110 shadow-lg"
            >
              ›
            </button>
            <div className="absolute bottom-2 sm:bottom-4 md:bottom-5 left-0 right-0 flex justify-center gap-1.5 sm:gap-2 md:gap-2.5 z-10">
              {sliderImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setSlideIndex(index)}
                  className={`rounded-full transition-all duration-300 ${index === slideIndex
                    ? "bg-[#E8B84B] w-4 sm:w-6 md:w-8 h-1.5 sm:h-2 md:h-2.5"
                    : "bg-white/60 hover:bg-white/80 w-1.5 sm:w-2 md:w-2.5 h-1.5 sm:h-2 md:h-2.5"
                    }`}
                ></button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ========== PRODUCT DETAIL VIEW ========== */}
      {view === "product" && selectedProduct && (
        <div className="max-w-4xl mx-auto px-5 sm:px-8 pt-2 pb-16">
          <div className="mb-6">
            <BackButton onClick={navigateToStore} label=" Back to Store" />
          </div>
          <div className="grid sm:grid-cols-2 gap-8 mb-12">
            <div className="rounded-2xl overflow-hidden bg-[#EDF1E6] aspect-square">
              <img src={selectedProduct.image} alt={selectedProduct.name} className="w-full h-full object-cover" />
            </div>
            <div>
              <h1 className="text-3xl text-[#3E5645] mb-2" style={display}>{selectedProduct.name}</h1>
              <div className="flex items-center gap-2 mb-4">
                <span className="text-[#E8B84B] text-lg">
                  {"★".repeat(Math.round(Number(avgRating) || selectedProduct.rating)) + "☆".repeat(5 - Math.round(Number(avgRating) || selectedProduct.rating))}
                </span>
                <span className="text-sm text-[#6B7A6E]">
                  {reviews.length > 0 ? `${avgRating} (${reviews.length} reviews)` : `${selectedProduct.rating.toFixed(1)} rating`}
                </span>
              </div>
              <div className="flex items-center gap-3 mb-4">
                <p className="text-[#3E5645] text-2xl font-bold">Rs. {selectedProduct.price}</p>
                {selectedProduct.originalPrice > selectedProduct.price && (
                  <p className="text-[#6B7A6E] text-lg line-through">Rs. {selectedProduct.originalPrice}</p>
                )}
              </div>
              <p className="text-[#6B7A6E] mb-6 leading-relaxed">{selectedProduct.description}</p>
              <button
                onClick={() => addToCart(selectedProduct)}
                className="bg-[#2F6FED] hover:bg-[#1E4FC7] text-white font-semibold px-8 py-3 rounded-xl shadow-md hover:shadow-lg transition-all"
              >
                Add to Cart
              </button>
            </div>
          </div>

          {/* ===== REVIEWS SECTION ===== */}
          <div className="border-t border-[#3E5645]/10 pt-10">
            <h2 className="text-2xl text-[#3E5645] mb-6" style={display}>
              Customer Reviews
              <span className="text-sm font-normal text-[#6B7A6E] ml-2">
                ({reviews.length})
              </span>
            </h2>
            <div className="space-y-5 mb-10">
              {reviews.length === 0 ? (
                <p className="text-[#6B7A6E]">Be the first to review this product 🌿</p>
              ) : (
                (showAllReviews ? reviews : reviews.slice(0, 3)).map((r) => (
                  <div key={r.id} className="bg-white border border-[#3E5645]/10 rounded-xl p-4">
                    <div className="flex items-center justify-between mb-1">
                      <span className="font-semibold text-[#3E5645] text-sm">{r.name}</span>
                      <span className="text-[#E8B84B] text-sm">{"★".repeat(r.rating) + "☆".repeat(5 - r.rating)}</span>
                    </div>
                    <p className="text-[#6B7A6E] text-sm leading-relaxed">{r.comment}</p>
                    {r.createdAt && (
                      <p className="text-[10px] text-[#A89B8C] mt-2">
                        {new Date(r.createdAt.seconds * 1000).toLocaleDateString()}
                      </p>
                    )}
                  </div>
                ))
              )}
            </div>
            {reviews.length > 3 && (
              <div className="text-center mb-8">
                <button
                  onClick={() => setShowAllReviews(!showAllReviews)}
                  className="text-[#2F6FED] font-semibold hover:underline"
                >
                  {showAllReviews ? "Show Less" : `Read More (${reviews.length - 3} more reviews)`}
                </button>
              </div>
            )}
            <div className="bg-white border border-[#3E5645]/10 rounded-2xl p-6">
              <h3 className="text-lg font-semibold text-[#3E5645] mb-4">Write a Review</h3>
              <form onSubmit={submitReview} className="space-y-4">
                <input
                  type="text"
                  placeholder="Your Name *"
                  value={reviewName}
                  onChange={(e) => setReviewName(e.target.value)}
                  className="w-full px-4 py-3 rounded-xl border border-[#3E5645]/20 bg-white focus:outline-none focus:border-[#3E5645] text-sm"
                />
                <div className="flex items-center gap-2">
                  <span className="text-sm text-[#3E5645] mr-2">Your Rating:</span>
                  {[1, 2, 3, 4, 5].map((star) => (
                    <button
                      key={star}
                      type="button"
                      onClick={() => setReviewRating(star)}
                      onMouseEnter={() => setHoverRating(star)}
                      onMouseLeave={() => setHoverRating(0)}
                      className="text-2xl focus:outline-none"
                    >
                      <span className={(hoverRating || reviewRating) >= star ? "text-[#E8B84B]" : "text-[#3E5645]/20"}>
                        ★
                      </span>
                    </button>
                  ))}
                </div>
                <textarea
                  placeholder="Share your experience with this product..."
                  value={reviewComment}
                  onChange={(e) => setReviewComment(e.target.value)}
                  rows={3}
                  className="w-full px-4 py-3 rounded-xl border border-[#3E5645]/20 bg-white focus:outline-none focus:border-[#3E5645] text-sm resize-none"
                />
                <button
                  type="submit"
                  disabled={submittingReview}
                  className={`px-6 py-3 rounded-xl font-semibold text-white transition-colors ${submittingReview ? "bg-[#2F6FED] cursor-not-allowed" : "bg-[#2F6FED] hover:bg-[#2F6FED]"}`}
                >
                  {submittingReview ? "Submitting..." : "Submit Review"}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* ========== STORE PRODUCT GRID ========== */}
      {view === "store" && (
        <div id="shop-collection" className="max-w-6xl mx-auto px-5 sm:px-8 py-14 sm:py-20">
          <div className="flex items-center gap-4 mb-8">
            <span className="h-px flex-1 bg-[#3E5645]/15"></span>
            <h2 className="text-blue-800 text-2xl sm:text-3xl" style={display}>Shop the Collection</h2>
            <span className="h-px flex-1 bg-[#3E5645]/15"></span>
          </div>

          {/* ===== DYNAMIC CATEGORY TABS WITH ALERT ===== */}
          {!loading && dbProducts.length > 0 && (
            <div className="flex flex-wrap items-center justify-center gap-2.5 sm:gap-3 mb-10">
              {categoryTabs.map((cat) => (
                <button
                  key={cat}
                  onClick={() => handleCategoryClick(cat)}
                  className={`px-5 sm:px-6 py-2.5 rounded-full text-sm font-semibold transition-all whitespace-nowrap ${
                    activeCategory === cat
                      ? "bg-[#3E5645] text-white shadow-md"
                      : "bg-white text-[#3E5645] border border-[#3E5645]/20 hover:border-[#3E5645]/50"
                  }`}
                >
                  {cat === "All" ? "🛍️ All" : `${getCategoryIcon(cat)} ${cat}`}
                </button>
              ))}
            </div>
          )}

          {loading ? (
            <div className="text-center py-12">
              <p className="text-[#6B7A6E]">Loading products...</p>
            </div>
          ) : dbProducts.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-[#6B7A6E] text-lg">No products available yet.</p>
              <p className="text-[#6B7A6E] text-sm mt-2">Check back soon for new arrivals!</p>
            </div>
          ) : filteredDbProducts.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-[#6B7A6E] text-lg">No products in "{activeCategory}" yet.</p>
              <p className="text-[#6B7A6E] text-sm mt-2">Check another category or check back soon!</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredDbProducts.map((product) => (
                <div
                  key={product.id}
                  onClick={() => {
                    setSelectedProduct(product);
                    setView("product");
                  }}
                  className="group bg-white rounded-2xl border border-[#3E5645]/10 overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1.5 hover:border-[#E8B84B]/50 transition-all duration-300 ease-out cursor-pointer"
                >
                  <div className="relative">
                    <ProductImageSlider images={[product.image, product.imageUrl2, product.imageUrl3, product.imageUrl4]} />
                    {renderBadge(product.badge)}
                    <div className="absolute top-3 right-3 bg-[#E8B84B] px-3 py-1.5 rounded-full shadow flex items-center gap-1.5">
                      {product.originalPrice > 0 && product.originalPrice > product.price && (
                        <span className="line-through opacity-70 font-normal text-[10px] text-[#3E5645]">
                          Rs. {product.originalPrice}
                        </span>
                      )}
                      <span className="text-[#3E5645] text-xs font-bold">
                        Rs. {product.price}
                      </span>
                    </div>
                    <div className="absolute inset-0 bg-[#2F4538]/0 group-hover:bg-[#2F4538]/5 transition-colors duration-300 pointer-events-none"></div>
                  </div>
                  <div className="p-5">
                    <h3 className="text-[#3E5645] text-lg font-semibold mb-1 group-hover:text-[#2F4538] transition-colors" style={display}>
                      {product.name}
                    </h3>
                    <div className="mb-2">
                      <StarRating rating={product.rating || 5} />
                    </div>
                    <p className="text-[#6B7A6E] text-sm mb-4 leading-relaxed">{product.description}</p>
                    <button
                      onClick={(e) => { e.stopPropagation(); addToCart(product); }}
                      className="w-full bg-[#2F6FED] hover:bg-[#1E4FC7] text-white text-sm font-semibold py-3 rounded-xl shadow-sm hover:shadow-md transition-all"
                    >
                      Add to Cart
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* ===== CART DRAWER ===== */}
      {cartOpen && (
        <>
          <div onClick={() => setCartOpen(false)} className="fixed inset-0 bg-black/40 z-40"></div>
          <div className="fixed top-0 right-0 w-full sm:w-[400px] h-full bg-[#FBF9F2] z-50 flex flex-col shadow-2xl">
            <div className="flex items-center justify-between px-6 py-5 border-b border-[#3E5645]/10 bg-white">
              <h2 className="text-xl text-[#3E5645]" style={display}>Your Basket</h2>
              <button onClick={() => setCartOpen(false)} className="text-2xl text-[#3E5645]/60 hover:text-[#3E5645]">×</button>
            </div>
            <div className="flex-1 overflow-y-auto px-6 py-5">
              {cart.length === 0 ? (
                <p className="text-[#6B7A6E] text-center mt-10">Your basket is empty </p>
              ) : (
                cart.map((item) => (
                  <div key={item.id} className="flex gap-3 mb-5 pb-5 border-b border-[#3E5645]/10">
                    <img src={item.image} alt={item.name} className="w-16 h-16 rounded-xl object-cover" />
                    <div className="flex-1">
                      <p className="text-sm font-semibold text-[#3E5645]">{item.name}</p>
                      <p className="text-xs text-[#6B7A6E] mb-2">
                        Rs. {item.price} × {item.qty} = Rs. {item.price * item.qty}
                      </p>
                      <div className="flex items-center gap-2">
                        <button onClick={() => updateQty(item.id, item.qty - 1)} className="w-7 h-7 border border-[#3E5645]/20 rounded-md text-[#3E5645] hover:bg-[#3E5645]/5">−</button>
                        <span className="text-sm text-[#3E5645] w-4 text-center">{item.qty}</span>
                        <button onClick={() => updateQty(item.id, item.qty + 1)} className="w-7 h-7 border border-[#3E5645]/20 rounded-md text-[#3E5645] hover:bg-[#3E5645]/5">+</button>
                        <button onClick={() => removeItem(item.id)} className="ml-auto text-xs text-[#C0563E] hover:underline">Remove</button>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
            {cart.length > 0 && (
              <div className="px-6 py-5 border-t border-[#3E5645]/10 bg-white">
                <div className="flex justify-between text-sm mb-2">
                  <span className="text-[#3E5645]">Delivery Charges</span>
                  {deliveryCharge === 0 ? (
                    <span className="text-green-600 font-semibold">Free</span>
                  ) : (
                    <span className="text-[#3E5645]">Rs. {deliveryCharge}</span>
                  )}
                </div>
                {deliveryCharge > 0 && (
                  <p className="text-[10px] text-[#6B7A6E] mb-3">
                    Rs. {FREE_DELIVERY_THRESHOLD - subtotal} ka aur order karein aur delivery free paayein 🚚
                  </p>
                )}
                <div className="flex justify-between font-semibold text-[#3E5645] mb-4 border-t border-[#3E5645]/10 pt-3">
                  <span>Subtotal</span>
                  <span>Rs. {grandTotal}</span>
                </div>
                <button
                  onClick={() => {
                    setCartOpen(false);
                    setView("checkout");
                    setTimeout(() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }, 100);
                  }}
                  className="w-full bg-[#2F6FED] hover:bg-[#1E4FC7] text-white py-3.5 rounded-xl font-semibold transition-colors"
                >
                  Checkout
                </button>
              </div>
            )}
          </div>
        </>
      )}

      {/* ===== CHECKOUT VIEW ===== */}
      {view === "checkout" && (
        <div className="max-w-2xl mx-auto px-5 sm:px-8 pt-2 pb-16">
          <div className="mb-6">
            <BackButton onClick={() => setView("store")} label="← Back to Store" />
          </div>
          <h2 className="text-2xl text-[#3E5645] mb-5" style={display}>Order Summary</h2>
          <div className="bg-white rounded-2xl border border-[#3E5645]/10 p-5 mb-8">
            {cart.map((item) => (
              <div key={item.id} className="flex justify-between text-sm text-[#3E5645] mb-2">
                <span>{item.name} × {item.qty}</span>
                <span>Rs. {item.price * item.qty}</span>
              </div>
            ))}
            <div className="flex justify-between text-sm text-[#3E5645] border-t border-[#3E5645]/10 mt-3 pt-3">
              <span>Subtotal</span>
              <span>Rs. {subtotal}</span>
            </div>
            <div className="flex justify-between text-sm mt-2">
              <span className="text-[#3E5645]">Delivery Charges</span>
              {deliveryCharge === 0 ? (
                <span className="text-green-600 font-semibold">Free</span>
              ) : (
                <span className="text-[#3E5645]">Rs. {deliveryCharge}</span>
              )}
            </div>
            {deliveryCharge > 0 && (
              <p className="text-[10px] text-[#6B7A6E] mt-1">
                Rs. {FREE_DELIVERY_THRESHOLD - subtotal} ka aur order karein aur delivery free paayein 🚚
              </p>
            )}
            {form.city && subtotal < FREE_DELIVERY_THRESHOLD && (
              <div className="mt-2 text-xs text-gray-500">
                {form.city === "Lahore" ? (
                  <span>📍 Lahore delivery: Rs. 250</span>
                ) : (
                  <span>📍 {form.city} delivery: Rs. 300</span>
                )}
              </div>
            )}
            <div className="flex justify-between font-bold text-[#3E5645] border-t border-[#3E5645]/10 mt-3 pt-3">
              <span>Total</span>
              <span>Rs. {grandTotal}</span>
            </div>
          </div>
          <h2 className="text-2xl text-[#3E5645] mb-4" style={display}>Delivery Details</h2>
          <form onSubmit={placeOrder} className="space-y-4">
            <input
              type="text"
              name="name"
              placeholder="Full Name *"
              value={form.name}
              onChange={handleFormChange}
              className="w-full px-4 py-3 rounded-xl border border-[#3E5645]/20 bg-white focus:outline-none focus:border-[#3E5645] text-sm"
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number *"
              value={form.phone}
              onChange={handleFormChange}
              className="w-full px-4 py-3 rounded-xl border border-[#3E5645]/20 bg-white focus:outline-none focus:border-[#3E5645] text-sm"
            />
            <input
              type="email"
              name="email"
              placeholder="Email Address *"
              value={form.email}
              onChange={handleFormChange}
              className="w-full px-4 py-3 rounded-xl border border-[#3E5645]/20 bg-white focus:outline-none focus:border-[#3E5645] text-sm"
            />
            <input
              type="text"
              name="address"
              placeholder="Full Address *"
              value={form.address}
              onChange={handleFormChange}
              className="w-full px-4 py-3 rounded-xl border border-[#3E5645]/20 bg-white focus:outline-none focus:border-[#3E5645] text-sm"
            />
            <div className="relative">
              <div
                className="w-full px-4 py-3 rounded-xl border border-[#3E5645]/20 bg-white focus:outline-none focus:border-[#3E5645] text-sm cursor-pointer flex items-center justify-between"
                onClick={() => setIsCityDropdownOpen(!isCityDropdownOpen)}
              >
                <span className={form.city ? "text-[#3E5645]" : "text-gray-400"}>
                  {form.city || "Select City *"}
                </span>
                <svg
                  className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${isCityDropdownOpen ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
              {isCityDropdownOpen && (
                <div className="absolute z-50 w-full mt-1 bg-white border border-[#3E5645]/20 rounded-xl shadow-lg max-h-60 overflow-hidden">
                  <div className="p-2 border-b border-[#3E5645]/10">
                    <input
                      type="text"
                      placeholder="Search city..."
                      value={searchCity}
                      onChange={(e) => setSearchCity(e.target.value)}
                      className="w-full px-3 py-2 rounded-lg border border-[#3E5645]/20 focus:outline-none focus:border-[#3E5645] text-sm"
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                  <div className="overflow-y-auto max-h-48">
                    {filteredCities.length > 0 ? (
                      filteredCities.map((city) => (
                        <div
                          key={city}
                          onClick={() => handleCitySelect(city)}
                          className={`px-4 py-2.5 hover:bg-blue-50 cursor-pointer transition-colors text-sm ${form.city === city ? 'bg-blue-50 text-blue-600 font-semibold' : 'text-[#3E5645]'
                            }`}
                        >
                          {city}
                        </div>
                      ))
                    ) : (
                      <div className="px-4 py-3 text-sm text-gray-400 text-center">
                        No cities found
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <textarea
              name="notes"
              placeholder="Order Notes (optional)"
              value={form.notes}
              onChange={handleFormChange}
              rows={3}
              className="w-full px-4 py-3 rounded-xl border border-[#3E5645]/20 bg-white focus:outline-none focus:border-[#3E5645] text-sm resize-none"
            />
            <div className="bg-[#FBF0DC] border border-[#E8B84B]/40 rounded-xl px-4 py-3 text-sm text-[#3E5645]">
              💵 Payment: <strong>Cash on Delivery</strong> — delivery ke waqt cash payment karein.
            </div>
            <button
              type="submit"
              disabled={sending}
              className={`w-full py-3.5 rounded-xl font-semibold text-white transition-colors ${sending ? "bg-blue-400 cursor-not-allowed" : "bg-[#2F6FED] hover:bg-[#1E4FC7]"}`}
            >
              {sending ? "Placing Order..." : "Place Order"}
            </button>
          </form>
        </div>
      )}

      {/* ===== SUCCESS VIEW ===== */}
      {view === "success" && (
        <div className="max-w-md mx-auto px-5 pt-2 pb-16 text-center">
          <div className="mb-6 text-left">
            <BackButton onClick={() => setView("store")} label="← Continue Shopping" />
          </div>
          <div className="mx-auto mb-5 w-20 h-20 rounded-full bg-green-500 flex items-center justify-center shadow-lg">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
          <h2 className="text-3xl text-blue-800 mb-3" style={display}>Order Placed!</h2>
          <p className="text-[#6B7A6E] mb-8">Thank you for your order — we'll reach out to you soon. A confirmation email has been sent to you.</p>
          <button onClick={() => setView("store")}
            className="bg-[#2F6FED] hover:bg-[#2F6FED] text-white px-6 py-3 rounded-xl font-semibold transition-colors">
            Continue Shopping
          </button>
        </div>
      )}

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes scaleIn {
          from { transform: scale(0.9); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
        @keyframes bounceIn {
          0% {
            opacity: 0;
            transform: scale(0.8) translateY(-20px);
          }
          50% {
            transform: scale(1.02) translateY(0);
          }
          70% {
            transform: scale(0.98);
          }
          100% {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }
        .animate-\\[bounceIn_0\\.4s_ease-out\\] {
          animation: bounceIn 0.4s ease-out;
        }
        .animate-\\[fadeIn_0\\.3s_ease-out\\] {
          animation: fadeIn 0.3s ease-out;
        }
        .animate-\\[scaleIn_0\\.3s_ease-out\\] {
          animation: scaleIn 0.3s ease-out;
        }
      `}</style>
    </div>
  );
}

export default Store;